import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
// import 'lib-flexible'//适配
// http://121.46.26.109:9089/index.html#/login
//分辨率适配
import 'lib-flexible/flexible.js'
import 'lib-flexible'
// 配置echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import router from './routes'
Vue.config.productionTip = false



// import axios from 'axios'
// Vue.prototype.$axios = axios

Vue.prototype.$bus = new Vue()

// import BASE_URL from "./api/index.js"
// Vue.prototype.BASE_URL=BASE_URL.ip
import {
	get,
	post
} from '@/api/axios.js'
Vue.prototype.$post = post
Vue.prototype.$get = get


new Vue({
	render: h => h(App),
	router,
}).$mount('#app')
